<template>
  <div class="register-select">
      <h3>请选择当前您注册猎上的身份</h3>
      <div class="item">
          <img src="../img/hc.png" alt="" />
          <span @click="go('hc')">我是猎企</span>
      </div>
      <div class="item" style="margin-top:100px;">
          <img src="../img/hh.png" alt="" />
          <span @click="go('hh')">我是猎头</span>
      </div>
  </div>
</template>
<style lang="scss" scoped>
  .register-select {
      h3 {
          text-align: center;
          margin-top: 40px;
          font-size: 20px;
      }
      .item {
          margin-top: 50px;
          text-align: center;
          img {
              display: block;
              width:28%;
              margin:0 auto;
          }
          span {
              display:inline-block;
              width:115px;
              height:35px;
              line-height:35px;
              margin-top:35px;
              background: #22Baa5;
              border-radius: 25px;
              text-align: center;
              color:#fff;
          }
      }
  }
</style>
<script>
export default {
  name: "register-select-module",
  data(){
    return {
        unionId:this.$route.query.unionId || '',
    }
  },
  watch: {
  },
  components: {},
  methods: {
      go(pages){
          let o = {};
          if(this.unionId){
              o.unionId = this.unionId;
          }
          this.$router.push({
              params:{
                  type:pages
              },
              query:o
          })
      }
  },
  created() {
      
  }
};
</script>
